export default "__VITE_ASSET__tla2b$dm__"